import { useQuery } from '@tanstack/react-query';

import { getTicketRequestSubCategories } from 'api/ticketRequestSubCategories';
import { RequestQueryKeysE, RequestStaleTimeE } from 'declarations/enums/react-query';
import { ApiErrorI } from 'declarations/interfaces/errors';
import { TicketRequestSubcategoryI } from 'declarations/interfaces/ticketRequestSubcategories';

type SubcategoryIRequestT = {
  isEnabled: boolean;
  roofTopId: string | undefined;
};

export const useFetchTicketRequestSubcategories = (params: SubcategoryIRequestT) => {
  return useQuery<TicketRequestSubcategoryI[], ApiErrorI>(
    [RequestQueryKeysE.FetchTicketRequestSubcategories, params.roofTopId],
    () => getTicketRequestSubCategories(),
    {
      enabled: params.isEnabled,
      staleTime: RequestStaleTimeE.TicketRequestCategories,
    }
  );
};
